<template>
  <div class="col-12">
    <div class="card card-height" :class="$attrs.class">
      <div class="p-3 pb-0 card-header">
        <div class="d-flex justify-content-between">
          <h5 class="mb-2">{{ title }}</h5>
        </div>
      </div>
      <div class="table-responsive">
        <full-table
          v-if="!!rows"
          :items="rows"
          :pagination="pagination"
          :headers="headers"
          :enable-search="false"
          @changed-page="paginationPageChange"
          @row-change="paginationRowChange"
        >
          <template #row="order">
            <slot name="row" v-bind="order"></slot>
          </template>

        </full-table>        
      </div>
    </div>
  </div>
</template>
<script>

import { FullTable } from "@/hotaka/components";

export default {
  name: "SalesTable",
  components: {
    FullTable,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "Numero",
    },
    pagination: {
      type: Object,
      default: () => ({
        total: 200,
        rows: 10,
        currentPage: 1,
        pages: {
          total: 10,
          current: 1,
        },
        entries: [5, 10, 15, 20]
      })
    },
    headers:{
      type: Array,
      default: () => ([
        {
          title: "",
          sort: false,
        }
        ])
    },
    rows: {
      type: Array,
      required: true,
      sales: [Number, String],
      value: String,
      bounce: String,
      country: {
        type: Array,
      },
    },
  },
  emits: ['changed-page', 'row-change'],
  data() {
    return {}
  },
  methods: {
    paginationPageChange(val) {
      this.$emit('changed-page', val);
    },
    paginationRowChange(val) {
      this.$emit('row-change', val);
    },
  }
};
</script>
<style scoped>

.table-responsive {
  padding: 1rem;
  min-height: 20rem;
}

.table-container {
  height: 17rem;
  overflow-x: hidden;
}
table {
  display: flex;
  flex-flow: column;
  height: 100%;
  width: 100%;
}
table thead {
  flex: 0 0 auto;
  text-align: left;
  width: calc(100% - 0.9em);
}
table tbody {
  flex: 1 1 auto;
  display: block;
  overflow-y: scroll;
  min-width: 48rem !important;
}
table tbody tr {
  width: 100%;
}
table thead,
table tbody tr {
  display: table;
  table-layout: fixed;
}
/* decorations */
.table-container {
    padding: 0.3em;
}
table td, table th {
    padding: 0.3em;
}

.card-height {
  min-height: 23.7rem !important;
}
</style>
